import PropTypes from "prop-types"
import React from "react"

const InsightSummary = ({ items }) => (
  <div className="flex items-center gap-2 text-sm">
    {items.map((item, index) => (
      <React.Fragment key={item.label}>
        {index > 0 && (
          <span className="text-gray-300" aria-hidden="true">
            &middot;
          </span>
        )}
        <span>
          <span className="font-semibold text-gray-900">{item.value}</span>{" "}
          <span className="text-gray-600">{item.label}</span>
        </span>
      </React.Fragment>
    ))}
  </div>
)

InsightSummary.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default InsightSummary
